// Accordion styles

import styled from 'styled-components';

import { media } from 'styles/utils';
import Heading from 'components/Heading';
import Button from 'components/Button';

export const Wrapper = styled.div`
  width: 100%;
  border: ${props =>
    props.variant === 'default' && `1px solid ${props.theme.color.wfGrey200}`};
  overflow: hidden;
`;

export const Head = styled.div`
  padding: ${props => props.theme.spacing[props.size]};
  padding-right: ${props => props.theme.spacing.xlarge};
  background-color: ${props =>
    props.variant === 'default'
      ? props.theme.color.wfGrey100
      : props.theme.color.wfGrey200};
  color: ${props => props.theme.color.wfGrey900};
  cursor: pointer;
  position: relative;
  /* Media queries */
  ${media.medium`
    padding: ${props =>
      props.size === 'default'
        ? props.theme.spacing.medium
        : props.theme.spacing.default};
  `}
`;

export const HeadingStyled = styled(Heading)`
  font-size: ${props => props.theme.font.size[props.size]};
`;

export const ButtonStyled = styled(Button)`
  top: 50%;
  right: ${props => props.theme.spacing[props.parentSize]};
  position: absolute;
  transform: translateY(-50%);
  /* Media queries */
  ${media.medium`
    right: ${props =>
      props.parentSize === 'default'
        ? props.theme.spacing.medium
        : props.theme.spacing.default};
  `}
`;

export const Body = styled.div`
  padding: ${props => props.theme.spacing[props.size]};
  line-height: 1.5;
  color: ${props => props.theme.color.wfGrey900};
  font-size: ${props => props.theme.font.size.default};
  display: ${props => (props.isVisible ? 'block' : 'none')};
  /* TODO: Remove p and ul elemens references once FAQ page can be refactored or removed */
  p:not(:last-of-type) {
    margin-bottom: ${props => props.theme.spacing.default};
  }
  p a {
    color: ${props => props.theme.color.primary};
  }
  ul {
    margin-bottom: ${props => props.theme.spacing.default};
  }
  /* Media queries */
  ${media.medium`
    padding: ${props =>
      props.size === 'default'
        ? props.theme.spacing.medium
        : props.theme.spacing.default};
  `}
`;
